import PropTypes from "prop-types";

import ServiceWrapper from "../utils/ServiceWrapper";

import { DB_USER_SERVICE, USER_ACTIVE_SCHOOL_YEAR, USER_SCHOOL_YEAR_RANGE } from "../const/UserConst";

/**
 * Data Access for the User API
 * @name UserDao
 * @param props
 * @return {null|*}
 */
const UserDao = (props) => {
    const { action, schoolYearKey, token, username } = props;
    const bearer = `Bearer ${token}`;
    const options = {
        headers: {
            Authorization: bearer
        },
        withCredentials: true
    };

    switch (action) {
        case "activeSchoolYearRead":
            options.method = "GET";
            options.url = USER_ACTIVE_SCHOOL_YEAR;
            break;
        case "userDetailsRead":
            options.method = "GET";
            options.url = `${DB_USER_SERVICE}/${username}/details.json`;
            break;
        case "userSchoolYearRange":
            options.method = "GET";
            options.url = `${USER_SCHOOL_YEAR_RANGE}/${schoolYearKey}/detail.json`;
            break;
        default:
            return null;
    }

    return ServiceWrapper.serviceCall({
        options,
        ...props
    });
};

UserDao.propTypes = {
    action: PropTypes.string.isRequired,
    icId: PropTypes.number,
    schoolYearKey: PropTypes.number,
    token: PropTypes.string.isRequired,
    username: PropTypes.string
};

UserDao.defaultProps = {
    icId: null,
    schoolYearKey: null,
    username: null
};

export default UserDao;
